<!--
 * @Description: Description
 * @Author: ranli
 * @Date: 2024-07-08 17:46:06
 * @LastEditTime: 2025-03-24 10:28:35
 * @LastEditors: ranli
-->
<script setup>
	import { useStore } from '@/stores';
	const props = defineProps({
		src: {
			type: [String],
			default: '',
		},
		height: {
			type: [Number, String],
			default: null,
		},
		width: {
			type: [Number, String],
			default: null,
		},
		className: {
			type: [String],
			default: '',
		},
		addBase: {
			type: [Boolean],
			default: false,
		},
		themColor: {
			type: [Boolean],
			default: false,
		},
	});
	const _Store = useStore();
	// 主题颜色
	const themeColor = computed(() => _Store.P_PARAMS.themeColor);
	// 定时器--获取数据的接口
	const base = process.env.VUE_APP_PUBLIC_PATH;
</script>

<template>
	<div
		:style="{
      '--img-width': width || 'auto',
      '--img-height': height || 'auto',
    }"
		:class="`${className}`"
		class="d-img"
	>
		<!-- lazy-load  -->
		<van-image
			width="100%"
			height="100%"
			class="d-van-image"
			:src="`${addBase ? base : ''}${src}`"
		>
			<template #error>
				<div class="dimg-error">
				</div>
			</template>
			<template #loading>
				<div class="dimg-loading">
				</div>
			</template>
		</van-image>
	</div>
</template>

<style lang="less">
	.d-van-image {
		display: block;
	}
	.d-img {
		.van-image__error,
		.van-image__loading {
			border-radius: 2px;
			background: white;
		}
	}
</style>

<style lang="less" scoped>
	@keyframes gradientAnimation {
		0% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
		}
	}
	.d-img {
		width: var(--img-width);
		height: var(--img-height);
		margin: auto;
		display: inline-block;
		.dimg-error,
		.dimg-loading {
			width: 100%;
			height: 100%;
			min-height: 10px;
			min-width: 10px;
			border-radius: 2px;
			animation: gradientAnimation 1.5s linear infinite;
			animation-play-state: running;
			background-image: linear-gradient(
				120deg,
				rgba(255, 255, 255, 0) 0%,
				#dfdedecc 50%,
				rgba(255, 255, 255, 0) 100%
			);
			background-size: 200% auto;
		}
	}
</style>
